import React from 'react'
import GridContainer from '../../components/Grid/GridContainer'
import GridItem from '../../components/Grid/GridItem'
import { Field, reduxForm } from 'redux-form'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'
import requisitionFormStyle from '../../assets/jss/requisitionFormStyle'
import {
    renderTextField
} from './RenderComponent'
import {
    FORM_REQUISITION
} from '../../utils/CommonConstant'
import {
    Button
} from '@material-ui/core'
import {
    interviewerValidation
} from '../form/Validation'

const InterviewerForm = (props) => {

    const {
        classes, 
        submitRequisition, 
        back,
        pristine,
        submitting,
    } = props

    return (
        <form className={classes.form} >
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        name="interviewer1"
                        label="Interviewer Name"
                        component={renderTextField}
                        style={classes.input}
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        name="interviewer2"
                        label="Interviewer Name"
                        component={renderTextField}
                        style={classes.input}
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        name="interviewer3"
                        label="Interviewer Name"
                        component={renderTextField}
                        style={classes.input}
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        name="interviewer4"
                        label="Interviewer Name"
                        component={renderTextField}
                        style={classes.input}
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        name="interviewer5"
                        label="Interviewer Name"
                        component={renderTextField}
                        style={classes.input}
                    />
                </GridItem>

                
                
                <GridItem xs={12} sm={12} md={12}>
                    <label>
                        Please refer to Recruitement Plicy, all panels should have a 
                        female as well as Myanmar person. All senior Executive roles
                        must have a shortlist of at least 1 female candidate.
                    </label>
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                      <div className="Button-Holder">
                        <Button
                          className={classes.prev_button}
                          variant="contained"
                          onClick={() => back()}>
                          Previous
                        </Button>
                      </div>
                      
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <div className="Button-Holder">
                      <Button
                        className={classes.button}
                        type="button"
                        variant="contained"
                        color ="secondary"
                        disabled={pristine || submitting}
                         onClick={() => submitRequisition()}
                        >
                            Submit
                        </Button>
                    </div>
                </GridItem>
                
            </GridContainer>
    </form> 
    )
} 

InterviewerForm.propTypes = {
    classes: PropTypes.object.isRequired
}

export default reduxForm({
    form: FORM_REQUISITION,
    validate: interviewerValidation,
    destroyOnUnmount: false,        
    forceUnregisterOnUnmount: true,
})(withStyles(requisitionFormStyle)(InterviewerForm))






















